import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { momentCategories, moments } from "@/mocks/moments";
import SectionHeading from "@/components/feature/SectionHeading";

export default function MomentsWall() {
  const [activeCategory, setActiveCategory] = useState("全部");

  const visible = useMemo(
    () =>
      activeCategory === "全部"
        ? moments
        : moments.filter((m) => m.category === activeCategory),
    [activeCategory]
  );

  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Famous Moments"
        title="名场面合集 · 高能瞬间"
        desc="三秒就能看懂的高光与翻车，被剪进二创最多的片段都在这里。"
        actionPath="/moments"
        actionLabel="进入名场面库"
      />

      <div className="mt-8 flex flex-wrap gap-2">
        {momentCategories.map((cat) => (
          <button
            key={cat}
            type="button"
            onClick={() => setActiveCategory(cat)}
            className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm transition-colors whitespace-nowrap ${
              activeCategory === cat
                ? "bg-foreground-900 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {visible.map((moment) => (
          <Link
            key={moment.id}
            to={`/topic/${moment.topicSlug}`}
            className="group rounded-lg overflow-hidden bg-background-100 flex flex-col"
          >
            <div className="relative w-full aspect-square">
              <img
                src={moment.image}
                alt={`${moment.title} — 名场面合集缩略图`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur text-xs font-medium text-secondary-800">
                {moment.category}
              </span>
              <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs">
                回放 {moment.heat}%
              </span>
            </div>
            <div className="p-4 flex-1 flex flex-col">
              <h3 className="font-heading font-bold text-base text-foreground-950 group-hover:text-primary-600 transition-colors">
                {moment.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-3 flex-1">
                {moment.desc}
              </p>
              <span className="mt-3 text-xs text-secondary-600">{moment.year} 年度名场面</span>
            </div>
          </Link>
        ))}
      </div>

      {visible.length === 0 && (
        <p className="mt-8 text-sm text-foreground-500">该分类暂无名场面，换个标签看看。</p>
      )}
    </section>
  );
}